import CommissionsPage from './CommissionsPage';

export default CommissionsPage;
